import React, { Component } from "react";
import _ from "lodash";
import { connect } from 'react-redux'

import { Button, Grid, Hidden, Link, Paper, Typography } from "@material-ui/core";

import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import ContentData from "../../types/ContentData";
import SelectedQuestionBenchmarks from "./SelectedQuestionBenchmarks";
import { QuestionBenchmarks } from "../../types/Benchmarks";
import { getTime, getTimeUnit } from "../../../../utils/getOffset.utils";
import StepWiseSolutionPreview from "./StepWiseSolutionPreview";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import AddFeedback from "../../../content-request/components/AddFeedback";
import { addNewFeedback, resolveFeedback, replyFeedback } from "../../../content-request/actions/contentRequestActions";
import { bindActionCreators } from "redux";
import ConceptIncludesPopup from "./ConceptIncludesPopup";
import { CONTENT_STATES, QUESTION_TYPE, QUESTION_TYPES } from "../../../../constants/comman";
import AddFeedbackPopup from "../ContentCreate/AddFeedbackPopup";
import { SECTIONS } from "../../helper/contentValidation";
import { getContentBucketName, getPropertyValue } from '../../../../utils';
import cx from 'classnames'
import { RemedialBasePreviewProps } from "./RemedialPreview/RemedialPreviewConstant";
import RemedialPreviewWrapper from "./RemedialPreview/RemedialPreviewWrapper";
import RemedialInfo from "./RemedialPreview/RemedialInfo";
import ContentPreviewRating from "../ContentRating/ContentPreviewRating";


const styles = (theme: Theme) =>
  createStyles({
    contentPaddingRight: {
      paddingRight: '25px',
    },

    keyValueContainer: {
      "& *": {
        display: "inline",
        marginRight: "4px",
      },
      marginTop: theme.spacing.unit * 2,
    },

    paddingLeftSM: {
      padding: '0px 0px 0px 36px'
    },

    textCenter: {
      textAlign: 'center'
    },
    solutionFeedbackBlock:{
      position: "absolute",
    left:374,
    zIndex: 9,
    },
    feedbackContainer: {
      position: 'relative',
      
      '& .feedbackBlock': {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
      '&.active': { 
        color: '#1D7DEA',
      },
    },
    secondaryConceptContainer: {
      borderTop: '1px solid #dfdfdf',
      paddingTop: '10px'
    },
    iconStyle: {
      "& img": {
        marginBottom: "2px",
      },
      '&>:first-child': {
        '&:nth-child(2)': {
          top: 14
        }
      }
    },

    marginBottomMD: {
      marginBottom: 24
    },

    overviewMeta: {
      opacity: 0.6,
    },

    metaInfoBox: {
      padding: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      background: "#FAFAFA",
      border: "1px solid #DDDDDD",
      boxSizing: "border-box",
      borderRadius: 4,
    },

    metaInfoBoxTable: {
      border: 0,
    },

    paddingSM: {
      padding: '0px 16px',
    },

    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p": {
        margin: 0,
        fontSize: 16
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },

    optionText: {
      display: "flex",
      whiteSpace: "nowrap",
      margin: "4px 0px",
      lineHeight: "38px",
      "& > span > p": {
        display: "inline",
        marginLeft: theme.spacing.unit,
      },
    },

    tagsList: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.unit,
      "&:after": {
        content: '"|"',
        marginLeft: theme.spacing.unit,
      },
      "&:last-child": {
        marginRight: 0,
        "&:after": {
          display: "none",
        },
      },
    },

    wrapText: {
      clear: "both",
      width: "100%",
      display: "inline-block",
      maxWidth: "96%",
      overflowX: "auto",
      whiteSpace: "initial",
      overflowY: "hidden",
      "& p": {
        margin: "0px",
        textAlign: "justify",
      },
    },

    widthSet: {
      width: "100%",
      "& .MyPATExpansionPanel-greyBackground-452": {
        backgroundColor: "#fff",
        background: "#fff !important",
      },
    },

    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },

    fontXS: {
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "#333",
    },

    blueColor: {
      color: "#1D7DEA",
    },

    greyColor: {
      color: "#333333",
    },
    greenColor: {
      color: "#67BF02"
    },
    feedbackHighlight:{
      cursor: 'pointer',
      '&:hover':{
        color: '#1d7dea',
      }
    },
    cursor:{
      cursor: 'pointer',
      fontWeight: 600,
    },
    studentContainer: {
      marginTop: '0',
      marginBottom: '12px'
    },
    studentInfo: {
      display: 'flex',
      gap: '10px'
    },
    showRemedialPaperStyle: {
      borderRadius: '0 0 4px 4px',
      borderTop: 'none',
    },
    customPaper: {
      backgroundColor: 'transparent',
    },
    forParagraphRemedialStyle: {
      background: 'rgba(255, 200, 44, 0.05)',
		  borderBottom: 'solid 20px #fff'
    },
    width100:{
      width: '100%'
    },
    line: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
      border: "1px solid #E6E6E6" ,
    },
    boxShadowNone: {
      boxShadow: 'none'
    }
  });

//@ts-ignore
interface MCQPreviewProps extends RemedialBasePreviewProps, WithStyles<typeof styles> {
  classes: any;
  content: ContentData;
  questionBenchmarks: QuestionBenchmarks;
  openFeedback: boolean;
  closeFeedback: Function;
  emptyClickedData: Function;
  authorType: string;
  contentRequestId: string;
  contentRequestItemId: string;
  addNewFeedback: Function;
  resolveFeedback: Function;
  replyFeedback: Function;
  clickedfeedbackData: any;
  handleFeedbackResolve: Function;
  feedbackData: any;
  questionSpecialPurposes: any;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: any;
  createNewValidationFeedback?: Function;
  handleAddCommentInFeedback?: Function;
  allowFeedbacks?: boolean;
  studentInfo?: any;
  toggleViewRating: Function;
  contentRatingInfo?: any;
  handleRateQuestionOpen?:Function;
}
interface MCQPreviewState {
  tag: string;
  conceptTypeToShow: 'primary' | 'secondary' | ''
}
class MCQPreview extends Component<MCQPreviewProps, MCQPreviewState> {
  constructor(props: MCQPreviewProps) {
    super(props);
    this.state = {
      tag: "question",
      conceptTypeToShow: ''
    }

    this.getConceptsTagged = this.getConceptsTagged.bind(this);
		this.getSecondaryConceptsTagged = this.getSecondaryConceptsTagged.bind(this);
    this.getSolutionContent = this.getSolutionContent.bind(this);
    this.addNewFeedback = this.addNewFeedback.bind(this);
    this.resolveFeedback = this.resolveFeedback.bind(this);
    this.replyFeedback = this.replyFeedback.bind(this);
    this.addFeedbackFromSolution = this.addFeedbackFromSolution.bind(this);
    this.closeFeedback = this.closeFeedback.bind(this);
    this.createNewValidationFeedback = this.createNewValidationFeedback.bind(this);
  }

  componentDidUpdate(prevProps: any) {
    if(prevProps.clickedfeedbackData !== this.props.clickedfeedbackData) {
      if(!_.isEmpty(this.props.clickedfeedbackData)){

      this.setState({
        tag: this.props.clickedfeedbackData.tag
      })
    } else {
      this.setState({
        tag: 'question'
      })
    }
  }
  }

	getConceptsTagged() {
    let { content, classes } = this.props;
		//  content = content.masterVariationQuestionId ? content.masterVariationQuestionData : content 
		return _.reduce(_.get(content, 'subjects', []), (acc: JSX.Element[], s) => {
			s.chapters.forEach(c => {
				c.concepts.forEach(cc => {
					let conceptName = _.get(cc, 'conceptId.name')
					let conceptCode = _.get(cc, 'conceptCode')
					if (conceptName) {
						acc.push(
							<Typography variant="body1">
								{conceptName}{' '}
								{conceptCode && (
									<Typography variant="h6" inline className={classes.fontXS}>(ID: {conceptCode})</Typography>
								)}
							</Typography>
						);
					}
					
				});
				
			})
			return acc;
		}, []);
  }
   addFeedback(tagName: string) {
    if (tagName === 'idealTime') {
      this.createNewValidationFeedback(SECTIONS.IDEAL_TIME);
    }
    if(!_.isEmpty(this.props.clickedfeedbackData)){
      this.props.emptyClickedData();
    }
    let clickedfeedbackData = this.props.feedbackData && (this.props.feedbackData.feedbacksData || []).filter((feedback: any) =>
    feedback.tag === tagName && !feedback.isResolved
    );
     if(clickedfeedbackData && clickedfeedbackData.length > 0) {
     this.props.handleFeedbackResolve(clickedfeedbackData[0])
    }
    setTimeout(() => {

    if(this.props.openFeedback) {
      this.setState({
        tag: tagName
      })
    }
  }, 200 );
 

  }
  closeFeedback(){
    this.props.closeFeedback()
  }
  addNewFeedback(text: string) {
    let feedbackData = {
      contentRequestId: this.props.contentRequestId, 
      contentId: _.get(this.props.content, `content._id`, ""), 
      comment: text, 
      role: this.props.authorType, 
      tag: this.state.tag, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.addNewFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }
  resolveFeedback(id: string) {
    let feedbackData = {
      feedbackId: id,
      role: this.props.authorType, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.resolveFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }
  replyFeedback(id: string, text: string) {
    let feedbackData = {
      feedbackId: id,
      contentRequestId: this.props.contentRequestId, 
      contentId: _.get(this.props.content, `content._id`, ""), 
      comment: text, 
      role: this.props.authorType, 
      tag: this.state.tag, 
      contentRequestItemId: this.props.contentRequestItemId, 
      contentType: 'question'
    }
    this.props.replyFeedback(feedbackData)
    this.props.closeFeedback('resolve');
  }
  addFeedbackFromSolution(update: string) {
   this.addFeedback('solution')
  }
	getSecondaryConceptsTagged() {
		let { content, classes } = this.props;
		// content = content.masterVariationQuestionId ? content.masterVariationQuestionData : content 
		if(content && content.secondarySubjects && content.secondarySubjects.length > 0) {
		return _.reduce(_.get(content, 'secondarySubjects', []), (acc: JSX.Element[], s, index) => {
			s.subSubjects.forEach(ss => {
			ss.chapters.forEach(c => {
				c.concepts.forEach(cc => {
					let conceptName = _.get(cc, 'conceptId.name')
					let conceptCode = _.get(cc, 'conceptCode')
					if (conceptName) {
						acc.push(
							<Typography variant="body1">
								{conceptName}{' '}
								{conceptCode && (
									<Typography variant="h6" inline className={classes.fontXS}>(ID: {conceptCode})</Typography>
								)}
							</Typography>
						);
					}
					
				});
				
			})
		})
			return acc;
		}, []);
	}
	}
	getSolutionContent(solutionContent: any) {
		return solutionContent === ("<p> <br></p>" || "")
		  ? "Not Available"
		  : solutionContent;
	  }

  renderTolerance(value: any) {
    if (value || value == 0) {
      return value;
    }
    return "Not Defined";
  }

  getIdealTime(time: number) {
    return `${getTime(time)} ${getTimeUnit(time)}`;
  }

  setConceptTypeToShow = (conceptTypeToShow: 'primary' | 'secondary' | '') => {
    this.setState({
      conceptTypeToShow
    })
  }

  createNewValidationFeedback(section: string) {
    const { createNewValidationFeedback, allowFeedbacks } = this.props;
    if (!allowFeedbacks) {
      return;
    }
    createNewValidationFeedback && createNewValidationFeedback(section);
  }
  renderRemedialBorderLine = () => {
    const { classes, showRemedial = false, remedialIndex = 0, prevSiblingQuestionType } = this.props;
		if (showRemedial || remedialIndex < 1 || prevSiblingQuestionType === QUESTION_TYPES.PARAGRAPH) return null;
    return <hr className={classes.line} />
  }
  getRemedialQuestionString = () => {
    const { showRemedial = false, remedialIndex = 0 } = this.props;
    return `Question ${!showRemedial ? remedialIndex + 1 : ''}:`;
  }
  renderRemedialQuestion = () => {
    const { showRemedial = false, remedialQuestion = [], classes, fromParagraph } = this.props;
    if (!showRemedial || !remedialQuestion || !remedialQuestion.length) return null;
    const mainRemedialStyle = cx(classes.paddingSM, classes.showRemedialPaperStyle,
      {
        [classes.boxShadowNone]: fromParagraph
      }
    );
    return (
      <>
        <RemedialInfo remedialQuestionLength={remedialQuestion.length} mainContainerClassName={mainRemedialStyle} classes={classes} />
        {remedialQuestion.map((question: any, index) => {
          const questionCode = question.content && question.content.questionCode;
          const prevRemedialQuestion: any = remedialQuestion[index ? index - 1 : 0];
          const prevRemedialQuestionType = prevRemedialQuestion.content && prevRemedialQuestion.content.questionCode;
          return (
            <div className={cx({ [classes.forParagraphRemedialStyle]: questionCode === QUESTION_TYPES.PARAGRAPH })}>
              <RemedialPreviewWrapper
                key={index}
                {...this.props}
                type={questionCode}
                showRemedial={false}
                content={question}
                remedialIndex={index}
                fromParagraph={false}
                prevSiblingQuestionType={prevRemedialQuestionType}
              />
            </div>
          )
        })}
      </>
    );
  }

  render() {
	const { classes, content, questionBenchmarks, clickedfeedbackData, questionSpecialPurposes, activeValidationFeedbackSection, activeValidationFeedbackData, allowFeedbacks, handleAddCommentInFeedback, showRemedial, fromParagraph, toggleViewRating, contentRatingInfo, handleRateQuestionOpen } = this.props;
  const { conceptTypeToShow } = this.state;
  // const _content = content.masterVariationQuestionId ? 'masterVariationQuestionData' : 'content'
  const _content = 'content'
  // const contentSubTypeCode = content.masterVariationQuestionId
  //       ? _.get(content.masterVariationQuestionData,'questionCode', '')
  //       : content.contentSubTypeCode
  const contentSubTypeCode = content.contentSubTypeCode;
  const primaryConceptsTagged = this.getConceptsTagged();
  const secondaryConceptsTagged = this.getSecondaryConceptsTagged();
    const studentName = getPropertyValue(this.props.studentInfo, 'authorName');
    const studentBatches = getPropertyValue(this.props.studentInfo, 'authorBatches', []).map((batches: any) => batches && batches.name).join(',');

  const correctAnswerData:Array<any> = _.map(_.get(content,"content.content[0].correctAnswer.data",[]));
    const mainRemedialStyle = cx(classes.paddingSM, classes.customPaper, {
    [classes.showRemedialPaperStyle]: !showRemedial,
    [classes.boxShadowNone]: fromParagraph
  });
  return (
      <>
        <Grid  direction="column">
          <Grid item className={classes.widthSet}>
            <Paper className={mainRemedialStyle} elevation={0}>
              {studentName && studentBatches && <div className={cx(classes.metaInfoBox,classes.studentContainer)}>
                <Grid container>
                  <Grid item xs={4} className={classes.studentInfo}>
                    <Typography
                      variant="body2"
                      onClick={() => this.addFeedback("questionType")}
                      className={cx(classes.fontSM, classes.greyColor)}
                    >
                      <span >
                        Student Name:
                      </span>
                    </Typography>
                    <Typography variant="body1">
                      {studentName}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={classes.studentInfo}>
                    <Typography
                      variant="body2"
                      className={cx(classes.fontSM, classes.greyColor)}
                    >
                      <span >
                        Batch:
                      </span>
                    </Typography>
                    <Typography variant="body1">
                      {studentBatches}
                    </Typography>
                  </Grid>
                </Grid>
              </div>}
              {content.masterVariationQuestionId && (
                <h3>Master Question Details</h3>
              )}
              {showRemedial && <div className={classes.metaInfoBox}>
                <Grid container>
                  <Grid item xs={4}>
                    <Typography
                      variant="body2"
                      onClick={() => this.addFeedback("questionType")}
                      className={[classes.fontSM, classes.greyColor].join(
                        " "
                      )}
                    >
                      <span
                        id={
                          this.props.openFeedback &&
                          this.state.tag === "questionType"
                            ? "feedbackScroll"
                            : ""
                        }
                        className={`${classes.feedbackContainer} ${
                          this.props.openFeedback &&
                          this.state.tag === "questionType"
                            ? classes.blueColor
                            : ""
                        } ${
                          this.props.openFeedback
                            ? classes.feedbackHighlight
                            : ""
                        }`}
                      >
                        Question Type:
                        {this.props.openFeedback &&
                          this.state.tag === "questionType" && (
                            <Grid className="feedbackBlock">
                              <AddFeedback
                                replyFeedback={this.replyFeedback}
                                closeFeedback={this.closeFeedback}
                                resolveFeedback={this.resolveFeedback}
                                clickedfeedbackData={clickedfeedbackData}
                                addNewFeedback={this.addNewFeedback}
                                author={this.props.authorType}
                              />
                            </Grid>
                          )}
                      </span>
                    </Typography>
                    <Typography variant="body1">
                      {QUESTION_TYPE[contentSubTypeCode.toString()]}
                    </Typography>
                  </Grid>

                  <Grid item xs={4} onClick={()=>this.createNewValidationFeedback(SECTIONS.TAGS)}>
                    {!content.masterVariationQuestionId && (
                      <div>
                        <Typography
                          variant="body2"
                          className={classes.fontSM}
                          onClick={() => this.addFeedback("tags")}
                        >
                          <span
                            id={
                              this.props.openFeedback &&
                              this.state.tag === "tags"
                                ? "feedbackScroll"
                                : ""
                            }
                            className={`${classes.feedbackContainer} ${
                              this.props.openFeedback &&
                              this.state.tag === "tags"
                                ? classes.blueColor
                                : ""
                            } ${
                              this.props.openFeedback
                                ? classes.feedbackHighlight
                                : ""
                            }`}
                          >
                            Tags:
                            {this.props.openFeedback &&
                              this.state.tag === "tags" && (
                                <Grid className="feedbackBlock">
                                  <AddFeedback
                                    replyFeedback={this.replyFeedback}
                                    closeFeedback={this.closeFeedback}
                                    resolveFeedback={this.resolveFeedback}
                                    clickedfeedbackData={
                                      clickedfeedbackData
                                    }
                                    addNewFeedback={this.addNewFeedback}
                                    author={this.props.authorType}
                                  />
                                </Grid>
                              )}
                              {
                                activeValidationFeedbackSection === SECTIONS.TAGS && (
                                  <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                                )
                              }
                          </span>
                        </Typography>
                        <Typography variant="body1" className={classes.contentPaddingRight}>
                          {_.map(
                            _.get(content, "content.tags", []),
                            (t, i: number) => (
                              <span className={classes.tagsList} key={i}>
                                {_.get(t, "relation.name", "-")}
                                {": "}
                                {_.isArray(_.get(t, "values", "-"))
                                  ? _.get(t, "values", "-").join(", ")
                                  : _.get(t, "values", "-")}
                              </span>
                            )
                          )}
                        </Typography>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={4} onClick={()=>this.createNewValidationFeedback(SECTIONS.DIFFICULTY)}>
                    <Typography
                      variant="body2"
                      onClick={() => this.addFeedback("difficulty")}
                      className={[classes.fontSM, classes.greyColor].join(
                        " "
                      )}
                    >
                      <span
                        id={
                          this.props.openFeedback &&
                          this.state.tag === "difficulty"
                            ? "feedbackScroll"
                            : ""
                        }
                        className={`${classes.feedbackContainer} ${
                          this.props.openFeedback &&
                          this.state.tag === "difficulty"
                            ? classes.blueColor
                            : ""
                        } ${
                          this.props.openFeedback
                            ? classes.feedbackHighlight
                            : ""
                        }`}
                      >
                        Difficulty:
                        {this.props.openFeedback &&
                          this.state.tag === "difficulty" && (
                            <Grid className="feedbackBlock">
                              <AddFeedback
                                replyFeedback={this.replyFeedback}
                                closeFeedback={this.closeFeedback}
                                resolveFeedback={this.resolveFeedback}
                                clickedfeedbackData={clickedfeedbackData}
                                addNewFeedback={this.addNewFeedback}
                                author={this.props.authorType}
                              />
                            </Grid>
                          )}
                          {
                            activeValidationFeedbackSection === SECTIONS.DIFFICULTY && (
                              <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                            )
                          }
                      </span>
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ textTransform: "capitalize" }}
                    >
                      Level:{" "}
                      {_.get(
                        content,
                        `${_content}.difficultyLevel`,
                        []
                      ).join(", ")}{" "}
                      <br />
                      Type:{" "}
                      {_.get(
                        content,
                        `${_content}.difficultyType`,
                        []
                      ).join(", ")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  {!content.masterVariationQuestionId && (
                    <>
                    <Grid item xs={8} onClick={()=>this.createNewValidationFeedback(SECTIONS.SYLLABUS)}>
                      <Typography
                        variant="body2"
                        onClick={() => this.addFeedback("concept")}
                        className={[classes.fontSM, classes.greyColor].join(
                          " "
                        )}
                      >
                        <span
                          id={
                            this.props.openFeedback &&
                            this.state.tag === "concept"
                              ? "feedbackScroll"
                              : ""
                          }
                          className={`${classes.feedbackContainer} ${
                            this.props.openFeedback &&
                            this.state.tag === "concept"
                              ? classes.blueColor
                              : ""
                          } ${
                            this.props.openFeedback
                              ? classes.feedbackHighlight
                              : ""
                          }`}
                        >
                          Concept Includes:
                          {this.props.openFeedback &&
                            this.state.tag === "concept" && (
                              <Grid className="feedbackBlock">
                                <AddFeedback
                                  replyFeedback={this.replyFeedback}
                                  closeFeedback={this.closeFeedback}
                                  resolveFeedback={this.resolveFeedback}
                                  clickedfeedbackData={clickedfeedbackData}
                                  addNewFeedback={this.addNewFeedback}
                                  author={this.props.authorType}
                                />
                              </Grid>
                            )}
                            {
                              activeValidationFeedbackSection === SECTIONS.SYLLABUS && (
                                <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                              )
                            }
                        </span>
                      </Typography>
                      <Grid container>
                        <Grid item xs={2}>
                          <Typography
                            variant="body2"
                            className={[
                              classes.fontSM,
                              classes.blueColor,
                            ].join(" ")}
                          >
                            Primary:
                          </Typography>
                        </Grid>
                        <Grid item xs>
                          {primaryConceptsTagged.slice(0, 3)}
                          {primaryConceptsTagged.length > 0 && (
                            <div>
                              <Link
                                className={classes.cursor}
                                color="primary"
                                onClick={() =>
                                  this.setConceptTypeToShow("primary")
                                }
                              >
                                View all
                              </Link>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                      {content &&
                        content.secondarySubjects &&
                        content.secondarySubjects.length > 0 && (
                          <Grid
                            container
                            className={classes.secondaryConceptContainer}
                          >
                            <Grid item xs={2}>
                              <Typography
                                variant="body2"
                                className={[
                                  classes.fontSM,
                                  classes.greenColor,
                                ].join(" ")}
                              >
                                Secondary:
                              </Typography>
                            </Grid>
                            <Grid item xs>
                              {secondaryConceptsTagged &&
                                secondaryConceptsTagged.slice(0, 3)}
                              <div>
                                <Link
                                  className={classes.cursor}
                                  color="primary"
                                  onClick={() =>
                                    this.setConceptTypeToShow("secondary")
                                  }
                                >
                                  View all
                                </Link>
                              </div>
                            </Grid>
                          </Grid>
                        )}
                    </Grid>
                  <Grid item xs={4}>
                    <div className={classes.titleDesc}>
                  <Typography
                    variant="body2"
                    className={classes.fontSM}
                    onClick={() => this.addFeedback("idealTime")}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.state.tag === "idealTime"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.state.tag === "idealTime"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Ideal Time:
                      {this.props.openFeedback &&
                        this.state.tag === "idealTime" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              replyFeedback={this.replyFeedback}
                              closeFeedback={this.closeFeedback}
                              resolveFeedback={this.resolveFeedback}
                              clickedfeedbackData={clickedfeedbackData}
                              addNewFeedback={this.addNewFeedback}
                              author={this.props.authorType}
                            />
                          </Grid>
                        )}
                        {
                          activeValidationFeedbackSection === SECTIONS.IDEAL_TIME && (
                            <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                          )
                        }
                    </span>
                    {/* <span className={classes.iconStyle}>
                      <CustomInfoIcon
                        isInfoIcon={true}
                        isCenterArrow={true}
                        isRightArrow={false}
                        knowMoreAbout={false}
                        dialogTitle="Ideal Time"
                        dialogPara=""
                        imageURL="/assets/svg/mylibrary/ideal-time.svg"
                        htmlElement={
                          <>
                            <Grid className={classes.paddingLeftSM}>
                              <h4>
                                Ideal time should be entered on the basis of
                                following guidelines:
                              </h4>
                              <Grid
                                container
                                className={classes.marginBottomMD}
                              >
                                <Typography>
                                  <strong>&#8226;&nbsp;</strong>
                                  For JEE(M) and JEE(A) Goal, ideal time
                                  should be set for top 1000 students
                                </Typography>
                                <Typography>
                                  <strong>&#8226;&nbsp;</strong>
                                  For CBSE Goal, ideal time should be set
                                  for student scoring greater and above 80%
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        }
                        toolTipDirection="top"
                        details="Click to know more"
                      />
                    </span> */}
                  </Typography>
                  <Typography variant="body1">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: this.getIdealTime(
                          _.get(
                            content,
                            "content.settings.idealTimeToSolve",
                            ""
                          )
                        ),
                      }}
                    />
                  </Typography>
                </div>
                  </Grid>
                  </>
                  )}
                  {content.masterVariationQuestionId && (
                    <>
                      <Grid item xs={4} onClick={()=>this.createNewValidationFeedback(SECTIONS.TAGS)}>
                        <Typography
                          variant="body2"
                          className={classes.fontSM}
                          onClick={() => this.addFeedback("tags")}
                        >
                          <span
                            id={
                              this.props.openFeedback &&
                              this.state.tag === "tags"
                                ? "feedbackScroll"
                                : ""
                            }
                            className={`${classes.feedbackContainer} ${
                              this.props.openFeedback &&
                              this.state.tag === "tags"
                                ? classes.blueColor
                                : ""
                            } ${
                              this.props.openFeedback
                                ? classes.feedbackHighlight
                                : ""
                            }`}
                          >
                            Tags:
                            {this.props.openFeedback &&
                              this.state.tag === "tags" && (
                                <Grid className="feedbackBlock">
                                  <AddFeedback
                                    replyFeedback={this.replyFeedback}
                                    closeFeedback={this.closeFeedback}
                                    resolveFeedback={this.resolveFeedback}
                                    clickedfeedbackData={
                                      clickedfeedbackData
                                    }
                                    addNewFeedback={this.addNewFeedback}
                                    author={this.props.authorType}
                                  />
                                </Grid>
                              )}
                              {
                                activeValidationFeedbackSection === SECTIONS.TAGS && (
                                  <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                                )
                              }
                          </span>
                        </Typography>
                        <Typography variant="body1" className={classes.contentPaddingRight}>
                          {_.map(
                            _.get(content, "content.tags", []),
                            (t, i: number) => (
                              <span className={classes.tagsList} key={i}>
                                {_.get(t, "relation.name", "-")}
                                {": "}
                                {_.isArray(_.get(t, "values", "-"))
                                  ? _.get(t, "values", "-").join(", ")
                                  : _.get(t, "values", "-")}
                              </span>
                            )
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} onClick={()=>this.createNewValidationFeedback(SECTIONS.SYLLABUS)}>
                        <Typography
                          variant="body2"
                          onClick={() => this.addFeedback("concept")}
                          className={[
                            classes.fontSM,
                            classes.greyColor,
                          ].join(" ")}
                        >
                          <span
                            id={
                              this.props.openFeedback &&
                              this.state.tag === "concept"
                                ? "feedbackScroll"
                                : ""
                            }
                            className={`${classes.feedbackContainer} ${
                              this.props.openFeedback &&
                              this.state.tag === "concept"
                                ? classes.blueColor
                                : ""
                            } ${
                              this.props.openFeedback
                                ? classes.feedbackHighlight
                                : ""
                            }`}
                          >
                            Concept Includes:
                            {this.props.openFeedback &&
                              this.state.tag === "concept" && (
                                <Grid className="feedbackBlock">
                                  <AddFeedback
                                    replyFeedback={this.replyFeedback}
                                    closeFeedback={this.closeFeedback}
                                    resolveFeedback={this.resolveFeedback}
                                    clickedfeedbackData={
                                      clickedfeedbackData
                                    }
                                    addNewFeedback={this.addNewFeedback}
                                    author={this.props.authorType}
                                  />
                                </Grid>
                              )}
                              {
                                activeValidationFeedbackSection === SECTIONS.SYLLABUS && (
                                  <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                                )
                              }
                          </span>
                        </Typography>
                        <Grid container>
                          <Grid item xs={2}>
                            <Typography
                              variant="body2"
                              className={[
                                classes.fontSM,
                                classes.blueColor,
                              ].join(" ")}
                            >
                              Primary:
                            </Typography>
                          </Grid>
                          <Grid item xs>
                            {primaryConceptsTagged.slice(0, 3)}
                            {primaryConceptsTagged.length > 0 && (
                              <div>
                                <Link
                                  className={classes.cursor}
                                  color="primary"
                                  onClick={() =>
                                    this.setConceptTypeToShow("primary")
                                  }
                                >
                                  View all
                                </Link>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        {content &&
                          content.secondarySubjects &&
                          content.secondarySubjects.length > 0 && (
                            <Grid
                              container
                              className={classes.secondaryConceptContainer}
                            >
                              <Grid item xs={2}>
                                <Typography
                                  variant="body2"
                                  className={[
                                    classes.fontSM,
                                    classes.greenColor,
                                  ].join(" ")}
                                >
                                  Secondary:
                                </Typography>
                              </Grid>
                              <Grid item xs>
                                {secondaryConceptsTagged &&
                                  secondaryConceptsTagged.slice(0, 3)}
                                <div>
                                  <Link
                                    className={classes.cursor}
                                    color="primary"
                                    onClick={() =>
                                      this.setConceptTypeToShow("secondary")
                                    }
                                  >
                                    View all
                                  </Link>
                                </div>
                              </Grid>
                            </Grid>
                          )}
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid container>
                  <Grid item xs={8}>
                    <Typography
                      variant="body2"
                      className={classes.fontSM}>
                      Bucket Type:
                    </Typography>
                    <Typography variant="body1">
                      {getContentBucketName(content)}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    {content.status === CONTENT_STATES.PUBLISHED && <ContentPreviewRating contentRatingInfo={contentRatingInfo} toggleViewRating={toggleViewRating} handleRateQuestionOpen={handleRateQuestionOpen} />}
                  </Grid>
                </Grid>
              </div>}
              {content.masterVariationQuestionId && (
                <div className={classes.titleDesc}>
                  <h4>Variation Question Details</h4>
                </div>
              )}
              {this.renderRemedialBorderLine()}
              <div className={classes.titleDesc} onClick={()=>this.createNewValidationFeedback(SECTIONS.CONTENT)}>
                <Typography
                  variant="body2"
                  onClick={() => this.addFeedback("question")}
                  className={[classes.fontSM, classes.greyColor].join(" ")}
                >
                  <span
                    id={
                      this.props.openFeedback &&
                      this.state.tag === "question"
                        ? "feedbackScroll"
                        : ""
                    }
                    className={`${classes.feedbackContainer} ${
                      this.props.openFeedback &&
                      this.state.tag === "question"
                        ? classes.blueColor
                        : ""
                    } ${
                      this.props.openFeedback
                        ? classes.feedbackHighlight
                        : ""
                    }`}
                  >
                    {this.getRemedialQuestionString()}
                    {this.props.openFeedback &&
                      this.state.tag === "question" && (
                        <Grid className="feedbackBlock">
                          <AddFeedback
                            replyFeedback={this.replyFeedback}
                            closeFeedback={this.closeFeedback}
                            resolveFeedback={this.resolveFeedback}
                            clickedfeedbackData={clickedfeedbackData}
                            addNewFeedback={this.addNewFeedback}
                            author={this.props.authorType}
                          />
                        </Grid>
                      )}
                      {
                        activeValidationFeedbackSection === SECTIONS.CONTENT && (
                          <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                        )
                      }
                  </span>

                  
                </Typography>

                <Typography variant="body1">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: _.get(
                        content,
                        "content.content[0].questionContent",
                        "-"
                      ),
                    }}
                  />
                </Typography>
              </div>

              <div className={classes.titleDesc}>
                {!_.includes(
                  ["3", "4", "6", "7"],
                  contentSubTypeCode.toString()
                ) && (
                  <div onClick={()=>this.createNewValidationFeedback(SECTIONS.OPTIONS)}>
                    <Typography
                      variant="body2"
                      className={classes.fontSM}
                      onClick={() => this.addFeedback("options")}
                    >
                      <span
                        id={
                          this.props.openFeedback &&
                          this.state.tag === "options"
                            ? "feedbackScroll"
                            : ""
                        }
                        className={`${classes.feedbackContainer} ${
                          this.props.openFeedback &&
                          this.state.tag === "options"
                            ? classes.blueColor
                            : ""
                        } ${
                          this.props.openFeedback
                            ? classes.feedbackHighlight
                            : ""
                        }`}
                      >
                        Options:
                        {this.props.openFeedback &&
                          this.state.tag === "options" && (
                            <Grid className="feedbackBlock">
                              <AddFeedback
                                replyFeedback={this.replyFeedback}
                                closeFeedback={this.closeFeedback}
                                resolveFeedback={this.resolveFeedback}
                                clickedfeedbackData={clickedfeedbackData}
                                addNewFeedback={this.addNewFeedback}
                                author={this.props.authorType}
                              />
                            </Grid>
                          )}
                          {
                            activeValidationFeedbackSection === SECTIONS.OPTIONS && (
                              <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                            )
                          }
                      </span>
                    </Typography>
                    <Typography variant="body1" component="div">
                      {_.map(
                        _.get(
                          content,
                          "content.content[0].optionsContent",
                          []
                        ),
                        (o, i: number) => (
                          <div key={i} className={classes.optionText}>
                            <span>&#40;{o.id}&#41;</span>&nbsp; &nbsp;{" "}
                            <div
                              className={classes.wrapText}
                              dangerouslySetInnerHTML={{ __html: o.value }}
                            />
                          </div>
                        )
                      )}
                    </Typography>
                  </div>
                )}
                <div className={classes.titleDesc}>
                  <Typography
                    variant="body2"
                    onClick={() => this.addFeedback("optionSettings")}
                    className={[classes.fontSM, classes.greyColor].join(
                      " "
                    )}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.state.tag === "optionSettings"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.state.tag === "optionSettings"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Option Settings:
                      {this.props.openFeedback &&
                        this.state.tag === "optionSettings" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              replyFeedback={this.replyFeedback}
                              closeFeedback={this.closeFeedback}
                              resolveFeedback={this.resolveFeedback}
                              clickedfeedbackData={clickedfeedbackData}
                              addNewFeedback={this.addNewFeedback}
                              author={this.props.authorType}
                            />
                          </Grid>
                        )}
                    </span>
                  </Typography>
                  <Typography variant="body1">
                    <span>
                      {" "}
                      {`${
                        _.get(
                          content,
                          "content.settings.option.shuffleType",
                          []
                        ) === "same"
                          ? "Same Sequence"
                          : "Random Sequence"
                      }  | Total ${_.get(
                        content,
                        "content.settings.option.displayCount",
                        []
                      )} options to be shown to students`}{" "}
                    </span>
                  </Typography>
                </div>
                <div className={classes.titleDesc} onClick={()=>this.createNewValidationFeedback(SECTIONS.ANSWER)}>
                  <Typography
                    variant="body2"
                    className={classes.fontSM}
                    onClick={() => this.addFeedback("answer")}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.state.tag === "answer"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.state.tag === "answer"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Correct Answer{ _.get(
                        content,
                        "content.content[0].customAnswer",
                        false
                      ) ? " (Custom Value)" : ""}:
                      {this.props.openFeedback &&
                        this.state.tag === "answer" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              replyFeedback={this.replyFeedback}
                              closeFeedback={this.closeFeedback}
                              resolveFeedback={this.resolveFeedback}
                              clickedfeedbackData={clickedfeedbackData}
                              addNewFeedback={this.addNewFeedback}
                              author={this.props.authorType}
                            />
                          </Grid>
                        )}
                        {
                          activeValidationFeedbackSection === SECTIONS.ANSWER && (
                            <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                          )
                        }
                    </span>
                  </Typography>
                  <Typography variant="body1">
                    {_.map(
                      _.get(
                        content,
                        "content.content[0].correctAnswer.data",
                        []
                      ),
                      (o, i: number) =>
                        contentSubTypeCode.toString() === "6" ? (
                          <span key={i}>
                            <div>{o.value}</div>
                            <div>
                              Positive Tolerance :{" "}
                              {this.renderTolerance(o.positiveTolerance)}
                            </div>
                            <div>
                              Negative Tolerance :{" "}
                              {o.negativeTolerance > 0 && "-"}
                              {this.renderTolerance(o.negativeTolerance)}
                            </div>
                          </span>
                        ) : contentSubTypeCode.toString() === "3" ? (
                          <div key={i}>
                            {i+1} : {o.value}
                          </div>
                        ) : (
                          <span
                            key={i}
                            dangerouslySetInnerHTML={{ __html: o.value }}
                          />
                        )
                    )}
                    {
                      ((
                          (((correctAnswerData || []).length === 0) ||
                          (correctAnswerData.length === 1 && ((((correctAnswerData || [])[0] || {})['value'] || '') === '') || (((correctAnswerData || [])[0] || {})['value'] === '<br>')) && (((correctAnswerData || [])[0] || {})['value'] !== 0))
                      )) && (<>Not Available</>)
                    }
                  </Typography>
                  {/* {_.get(
                    content,
                    "content.content[0].correctAnswer.data",
                    []
                  ).length == 0 && (
                    <Typography variant="body1" color="error">
                      Answer must be entered in a question
                    </Typography>
                  )} */}
                </div>
                {this.props.openFeedback && this.state.tag === "solution" && (
                  <Grid className={classes.solutionFeedbackBlock}>
                    <AddFeedback
                      replyFeedback={this.replyFeedback}
                      closeFeedback={this.closeFeedback}
                      resolveFeedback={this.resolveFeedback}
                      clickedfeedbackData={clickedfeedbackData}
                      addNewFeedback={this.addNewFeedback}
                      author={this.props.authorType}
                    />
                  </Grid>
                )}
                <StepWiseSolutionPreview
                  openFeedback={this.props.openFeedback}
                  updateTagName={this.addFeedbackFromSolution}
                  onSectionClick={()=>this.createNewValidationFeedback(SECTIONS.SOLUTION)}
                  data={_.get(
                    content,
                    "content.content[0].stepWiseSolution",
                    []
                  )}
                  showColor={
                    this.props.openFeedback && this.state.tag === "solution"
                  }
                  showValidationFeedback={activeValidationFeedbackSection === SECTIONS.SOLUTION}
                  feedbackData={activeValidationFeedbackData}
                  allowFeedbacks={allowFeedbacks}
                  handleAddFeedback={handleAddCommentInFeedback} 
                  handleCloseFeedback={()=>this.createNewValidationFeedback('')}
                />

                <div className={classes.titleDesc} onClick={()=>this.createNewValidationFeedback(SECTIONS.HINTS)}>
                  <Typography
                    variant="body2"
                    className={[classes.fontSM, classes.greyColor].join(
                      " "
                    )}
                    onClick={() => this.addFeedback("hints")}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.state.tag === "hints"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.state.tag === "hints"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Hints:
                      {this.props.openFeedback &&
                        this.state.tag === "hints" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              replyFeedback={this.replyFeedback}
                              closeFeedback={this.closeFeedback}
                              resolveFeedback={this.resolveFeedback}
                              clickedfeedbackData={clickedfeedbackData}
                              addNewFeedback={this.addNewFeedback}
                              author={this.props.authorType}
                            />
                          </Grid>
                        )}
                        {
                          activeValidationFeedbackSection === SECTIONS.HINTS && (
                            <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                          )
                        }
                    </span>
                  </Typography>
                  <Typography variant="body1">
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: _.get(
                          content,
                          "content.content[0].questionHints",
                          null
                        ),
                      }}
                    />
                  </Typography>
                </div>

                {/* <div className={classes.titleDesc}>
                <Typography variant="body2" className={classes.fontSM}>
                  Solutions:{" "}
                </Typography>
                <Typography variant="body1">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.getSolutionContent(
                        _.get(content, "content.content[0].solutionContent", [])
                      ),
                    }}
                  />
                </Typography>
              </div>
			  { !content.masterVariationQuestionId && 
              </div> */}

                <div className={classes.titleDesc} onClick={()=>this.createNewValidationFeedback(SECTIONS.RELEVANT_EXAMS)}>
                  <Typography
                    variant="body2"
                    className={[classes.fontSM, classes.greyColor].join(
                      " "
                    )}
                    onClick={() => this.addFeedback("relevantExams")}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.state.tag === "relevantExams"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.state.tag === "relevantExams"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Relevant Exams:
                      {this.props.openFeedback &&
                        this.state.tag === "relevantExams" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              replyFeedback={this.replyFeedback}
                              closeFeedback={this.closeFeedback}
                              resolveFeedback={this.resolveFeedback}
                              clickedfeedbackData={clickedfeedbackData}
                              addNewFeedback={this.addNewFeedback}
                              author={this.props.authorType}
                            />
                          </Grid>
                        )}
                        {
                          activeValidationFeedbackSection === SECTIONS.RELEVANT_EXAMS && (
                            <AddFeedbackPopup allowFeedbacks={allowFeedbacks} handleAdd={handleAddCommentInFeedback} handleCancel={()=>this.createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                          )
                        }
                    </span>
                  </Typography>
                  <Typography variant="body1">
                    {_.map(
                      _.get(content, `${_content}.relevantExams`, []),
                      (t, i: number) => (
                        <span key={i}>
                          {_.get(t, "name", "-")}&nbsp;&nbsp;
                          {`${
                            _.get(content, `${_content}.relevantExams`, [])
                              .length -
                              1 !==
                            i
                              ? "|"
                              : ""
                          }`}
                          &nbsp;&nbsp;
                        </span>
                      )
                    )}
                    {
                      (_.get(content, `${_content}.relevantExams`, []).length === 0) && 'Not Available'
                    }
                  </Typography>
                </div>
                <SelectedQuestionBenchmarks 
                  onSectionClick={()=>this.createNewValidationFeedback(SECTIONS.BENCHMARKING)}
                  allowFeedbacks={allowFeedbacks}
                  handleAddFeedback={handleAddCommentInFeedback} 
                  handleCloseFeedback={()=>this.createNewValidationFeedback('')}
                  showValidationFeedback={activeValidationFeedbackSection === SECTIONS.BENCHMARKING}
                  feedbackData={activeValidationFeedbackData} 
                  questionSpecialPurposes={questionSpecialPurposes} data={questionBenchmarks} />
              </div>
            </Paper>
            {this.renderRemedialQuestion()}
          </Grid>
        </Grid>
        {!!conceptTypeToShow && (
          <ConceptIncludesPopup
            onClose={() => this.setConceptTypeToShow("")}
            primaryConcepts={primaryConceptsTagged}
            secondaryConcepts={secondaryConceptsTagged}
            conceptType={conceptTypeToShow}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  questionSpecialPurposes: state.questionCreate.specialPurposes,
});
const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    addNewFeedback: addNewFeedback,
    resolveFeedback: resolveFeedback,
    replyFeedback: replyFeedback
  },
  dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MCQPreview));
